export { default } from './AboutTheCourse';
